import { render, staticRenderFns } from "./create-or-edit-sysclassify.vue?vue&type=template&id=6c0e1200&scoped=true"
import script from "./create-or-edit-sysclassify.vue?vue&type=script&lang=js"
export * from "./create-or-edit-sysclassify.vue?vue&type=script&lang=js"
import style0 from "./create-or-edit-sysclassify.vue?vue&type=style&index=0&id=6c0e1200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0e1200",
  null
  
)

export default component.exports